import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { clock } from '#apps/client-web/app/services/clock';
import { auditService } from '#apps/client-web/features/audit/services/audit';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';

import { AuditCreatePageContainer } from './audit-create-page.container';
import { useAuditCreatePageViewModel } from './audit-create-page.view-model';

export const AuditCreatePage = () => {
  const logger = useLogger('pages/audit-create');

  const viewModel = useAuditCreatePageViewModel({
    auditService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    clock,

    logger,
  });

  return (
    <FormPageLayout
      title="New Audit"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.page.state === 'pending'}>
      <CenteredLayout horizontal>
        <AuditCreatePageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
